import { render, staticRenderFns } from "./personAuth.vue?vue&type=template&id=144f3d30&scoped=true&"
import script from "./personAuth.vue?vue&type=script&lang=js&"
export * from "./personAuth.vue?vue&type=script&lang=js&"
import style0 from "./personAuth.vue?vue&type=style&index=0&id=144f3d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144f3d30",
  null
  
)

export default component.exports